import { render, staticRenderFns } from "./addFeeTemplate.vue?vue&type=template&id=427a5f4c&lang=pug"
import script from "./addFeeTemplate.vue?vue&type=script&lang=js"
export * from "./addFeeTemplate.vue?vue&type=script&lang=js"
import style0 from "./addFeeTemplate.vue?vue&type=style&index=0&id=427a5f4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports